export const RULESETS = {
  ALL: 'all',
  SINGLE_FAMILY: 'single-family',
  SINGLE_COUPLE_FAMILY: 'single-couple-family',
};
